<app-table
  [table_config]="table_config"
  [array]="outputs"
  [loader]="loader"
  (onEliminarSalida)="downloadFile($event)"
  (onEliminarEntryExport)="confirm($event)"
  (onDetalleSalida)="mostrarSalida($event, 'detalle')"
  (onActualizarSalida)="mostrarSalida($event, 'actualizar')"
></app-table>
<app-overlay
  *ngIf="salidaEliminar"
  [buttons]="true"
  mensaje="¿Estás seguro de eliminar la salida {{ cuurentOutputId }}?"
  (onDeleteLote)="deleteSalida($event)"
></app-overlay>
<div class="overlay-detalle" *ngIf="overlaySalida">
  <div class="detalle-salida">
    <div class="table-header">
      <h2 class="title">
        <span (click)="closeDetalle()">
          <app-arrow-back></app-arrow-back>
        </span>
        {{ subtitulo }}
      </h2>
    </div>
    <app-cabotaje-form-salida-barco
      [blDetails]="blDetails"
      [containerStyles]="containerStyles"
      [outputDetail]="outputDetail"
      [movimiento]="movimiento"
      [outputTypes]="outputTypes"
      [nationalPorts]="nationalPorts"
      [boats]="boats"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 1 && !loaderOverlay"
    ></app-cabotaje-form-salida-barco>
    <app-cabotaje-form-salida-desistimiento
      [blDetails]="blDetails"
      [containerStyles]="containerStyles"
      [outputDetail]="outputDetail"
      [tipoTransporte]="transportType"
      [tipoUnidad]="unitType"
      [listTransportLine]="listTransportLine"
      [originsTicket]="originsTicket"
      [transportList]="transportList"
      [movimiento]="movimiento"
      [outputTypes]="outputTypes"
      [archivos]="archivos"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 2 && !loaderOverlay"
    ></app-cabotaje-form-salida-desistimiento>
    <app-cabotaje-form-salida-merma
      [blDetails]="blDetails"
      [containerStyles]="containerStyles"
      [boats]="boats"
      [outputDetail]="outputDetail"
      [movimiento]="movimiento"
      [outputTypes]="outputTypes"
      [archivos]="archivos"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 3 && !loaderOverlay"
    ></app-cabotaje-form-salida-merma>
    <app-cabotaje-form-salida-traspaso
      [containerStyles]="containerStyles"
      [outputDetail]="outputDetail"
      [movimiento]="movimiento"
      [batchesAvailableTransfer]="batchesAvailableTransfer"
      [outputTypes]="outputTypes"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 4 && !loaderOverlay"
    ></app-cabotaje-form-salida-traspaso>
    <app-output-form-to-another-patio
      [blDetails]="blDetails"
      [outputTypes]="outputTypes"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      [movimiento]="movimiento"
      [outputDetail]="outputDetail"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 5 && !loaderOverlay"
    ></app-output-form-to-another-patio>
    <app-cabotaje-form-salida-acuerdo-aduanal
      [blDetails]="blDetails"
      [containerStyles]="containerStyles"
      [outputDetail]="outputDetail"
      [tipoTransporte]="transportType"
      [listTransportLine]="listTransportLine"
      [tipoUnidad]="unitType"
      [originsTicket]="originsTicket"
      [transportList]="transportList"
      [movimiento]="movimiento"
      [outputTypes]="outputTypes"
      [boats]="boats"
      [archivos]="archivos"
      [locations]="locations"
      [amountsPerYardList]="amountsPerYardList"
      (onRegresar)="closeDetalle()"
      *ngIf="tipoSalida === 6 && !loaderOverlay"
    ></app-cabotaje-form-salida-acuerdo-aduanal>
    <app-loader class="loader" *ngIf="loaderOverlay"></app-loader>
  </div>
</div>
<app-overlay
  *ngIf="loading"
></app-overlay>
<app-overlay
  icono="bi bi-info-circle-fill"
  [mensaje]="message"
  *ngIf="file"
></app-overlay>
<app-overlay
*ngIf="overlayError"
[reload]="true"
></app-overlay>
<app-overlay
  *ngIf="overlay"
  [icono]="icon"
  [mensaje]="mensaje"
></app-overlay>
